import summaryStore from "@/store/summary.store";
import IconSpeakerAdd from "@/assets/common/ic_speaker_add.svg?react";
import Tooltip from "@/component/Tooltip";
import summaryCommonStore from "@/store/summaryCommon.store";
import SpeakerItem from "./SpeakerItem";
import "./index.less";

interface SpeakerListProps {
  module: "todo";
  index: number;
  speakerList: string[];
}
const SpeakerList: React.FC<SpeakerListProps> = (props) => {
  const newSummary = summaryStore((state) => state.newSummary);
  const modifySummary = summaryStore((state) => state.modifySummary);
  const summaryEditing = summaryCommonStore((state) => state.summaryEditing);

  const { speakerList, index, module } = props;

  const handleSetSpeaker = (index: number, newSpeakerList: string[]) => {
    console.log("handleSetSpeaker");
    if (!newSummary) return;
    const newSummaryArr = [...newSummary[module]];
    const oldItem = newSummaryArr[index];
    const [item] = oldItem.split("@");
    newSummaryArr[index] = `${item}${
      newSpeakerList.length > 0 ? "@" : ""
    }${newSpeakerList.join("@")}`;
    console.log("newSummary", newSummaryArr);
    modifySummary({
      ...newSummary,
      [module]: newSummaryArr,
    });
  };

  // 添加责任人
  const handleAddSpeaker = () => {
    if (!newSummary) return;
    handleSetSpeaker(index, [...speakerList, ""]);
  };

  const handleDelSpeaker = (index: number, speakerIndex: number) => {
    if (!newSummary) return;
    const newSpeakerList = [...speakerList];
    newSpeakerList.splice(speakerIndex, 1);
    handleSetSpeaker(index, newSpeakerList);
  };

  // 修改责任人
  const handleSpeakerChange = (
    index: number,
    speakerIndex: number,
    value: string
  ) => {
    console.log("handleSpeakerChange", index, speakerIndex, value);
    if (!newSummary) return;
    const newSpeakerList = [...speakerList];
    // 更新值
    newSpeakerList[speakerIndex] = value;
    handleSetSpeaker(index, newSpeakerList);
  };

  return (
    <>
      {speakerList.map((speakerItem, speakerIndex) => {
        return (
          <SpeakerItem
            key={speakerIndex}
            speakerItem={speakerItem}
            summaryEditing={summaryEditing}
            handleDelSpeaker={() => handleDelSpeaker(index, speakerIndex)}
            handleSpeakerInput={(value) => {
              handleSpeakerChange(index, speakerIndex, value);
            }}
          />
        );
      })}
      {summaryEditing && (
        <Tooltip content="添加责任人">
          <span
            className="relative translate-y-1 cursor-pointer mr-2 rounded-2 w-5.5 h-5.5 inline-flex items-center justify-center"
            onClick={handleAddSpeaker}
          >
            <IconSpeakerAdd />
          </span>
        </Tooltip>
      )}
    </>
  );
};

export default SpeakerList;
